export class Activity {
    public id: number;
    public name: string;
    public description: string;
    public rootPath: string;
    public priority: number;
    public tasks: any[];
    public assignedRoleId: number;
    public assignedRole: any;
    public nrOfTasks: number;

    constructor(activity: any = {}) {
        this.id = activity.id || 0;
        this.name = activity.name || '';
        this.description = activity.description || '';
        this.rootPath = activity.rootPath || '';
        this.priority = activity.priority || 0;
        this.tasks = activity.tasks || [];
        this.assignedRoleId = activity.assignedRoleId || 0;
        this.assignedRole = activity.assignedRole || null;
        this.nrOfTasks = activity.nrOfTasks || 0;
    }

    get type() {
        return 'activity';
    }
}
